/* Preserve the current theme's explicit-size-selection gate and native variant events. */
(function(){
  'use strict';
  if(window.klaydSizingOnlyBound)return;
  window.klaydSizingOnlyBound=true;
  function markSizeChosen(event){
    if(!(event.target instanceof Element))return;
    var input=event.target.closest('input[data-klayd-size-input]');
    if(!input){
      var label=event.target.closest('.klayd-size-choice label');
      if(label)input=document.getElementById(label.htmlFor);
    }
    if(!input||!input.matches('input[data-klayd-size-input]'))return;
    var content=input.closest('.product__content');
    if(content)content.classList.add('unload');
  }
  document.addEventListener('click',markSizeChosen,true);
  document.addEventListener('change',markSizeChosen,true);
})();
